import { styled } from '@mui/material';
import type { ReactNode } from 'react';

import { PROVIDER_LIST_CONTAINER } from './providerListContainer';

type Props = {
  children: ReactNode;
  'aria-label': string;
  'aria-busy'?: boolean;
  'data-testid'?: string;
};

const List = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  containerType: 'inline-size',
  containerName: PROVIDER_LIST_CONTAINER,
  '& > li + li': {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

/**
 * Directory of `ProviderListItem` rows separated by hairline dividers.
 * Rows stack on narrow widths and switch to columns once the list itself is wide enough
 * (container query, not viewport).
 */
export function ProviderList(props: Props) {
  return (
    <List
      aria-label={props['aria-label']}
      aria-busy={props['aria-busy']}
      data-testid={props['data-testid'] ?? 'provider-list'}
    >
      {props.children}
    </List>
  );
}

export type { Props as ProviderListProps };
